export default {
  brand: {
    name: 'VILLAGARAGE',
    tagline: 'Premium Garage Systems',
  },
  nav: {
    home: 'الرئيسية',
    garage: 'أنظمة المرآب',
    villa: 'مشاريع الفلل',
    winter: 'الحديقة الشتوية',
    projects: 'المشاريع',
    about: 'من نحن',
    contact: 'اتصل بنا',
    dealer: 'الوكالة والشراكة',
    login: 'دخول الأعضاء / الوكلاء',
    cta: 'اطلب عرض سعر لمشروعك',
  },
  hero: {
    title1: 'أنظمة مرآب فاخرة',
    title2: 'تضيف قيمة إلى فيلتك',
    subtitle: 'حلول مرآب مغلق فاخرة مصممة حسب الهندسة المعمارية لمشاريع الفلل الفاخرة والفلل الخاصة.',
    cta1: 'اطلب عرض سعر لمشروعك',
    cta2: 'استكشف أنظمة المرآب',
    small: 'أنظمة لسيارة أو سيارتين • تصميم معماري مخصص • حلول حسب المشروع',
  },
  s1: {
    title: 'لا ينبغي أن يكون المرآب إضافة متأخرة إلى فيلتك.',
    text: 'تتعامل VILLAGARAGE مع المرآب ليس كبنية مستقلة، بل كجزء لا يتجزأ من عمارة الفيلا.',
    f1: 'تصميم معماري مخصص',
    f2: 'مظهر فاخر',
    f3: 'حماية للمركبة طوال الفصول',
  },
  s2: {
    title: 'نفس الفيلا. مستوى معيشة مختلف.',
    openTitle: 'موقف مكشوف',
    openDesc: 'المركبة معرضة للعوامل الجوية. يفتقر إلى التكامل المعماري. لا يضيف قيمة للمشروع.',
    garageTitle: 'مرآب VILLAGARAGE الفاخر',
    garageDesc: 'مركبة محمية طوال العام. يندمج مع عمارة الفيلا. يضيف قيمة فاخرة للمشروع.',
    cta: 'اطلب حلًا لمشروعك',
  },
  s3: {
    title: 'أنظمة المرآب',
    cta: 'استكشف',
    card1: {
      title: 'مرآب فاخر لسيارة واحدة',
      desc: 'مرآب فاخر مدمج وأنيق ومصمم حسب العمارة لسيارة واحدة.',
    },
    card2: {
      title: 'مرآب فاخر لسيارتين',
      desc: 'مرآب فاخر واسع ومريح يندمج بسلاسة مع فيلتك لسيارتين.',
    },
    card3: {
      title: 'أنظمة مرآب مخصصة للمشروع',
      desc: 'حلول مصممة خصيصًا لمشاريع الفلل والمتطلبات الفريدة.',
    },
  },
  s4: {
    title1: 'لا توجد فيلتان متشابهتان.',
    title2: 'ولا ينبغي أن تكون مرائبهما كذلك.',
    d1: 'أنظمة معمارية بلون الأنثراسيت',
    d2: 'تفاصيل من الخشب الطبيعي',
    d3: 'إضاءة معمارية',
    d4: 'تصاميم واجهات مخصصة',
    d5: 'حلول لسيارة أو سيارتين',
  },
  s5: {
    title: 'تفصيلة تميز مشاريع الفلل عن المألوف',
    subtitle: 'VILLAGARAGE لشركات المقاولات ومطوري المشاريع والمهندسين المعماريين.',
    b1: 'تصميم مخصص لكل مشروع',
    b2: 'التكامل مع عمارة الفيلا',
    b3: 'هيكل مناسب لمشاريع الفلل المتعددة',
    b4: 'انطباع فاخر عن المشروع',
    b5: 'حلول لسيارة واحدة / سيارتين',
    b6: 'نهج نظامي بديل لعمليات البناء التقليدية الثقيلة',
    cta: 'أرسل مشروع فيلتك',
  },
  s6: {
    title: 'لا تترك سيارتك الفاخرة معرضة طوال العام.',
    text: 'أنشئ مساحة فاخرة أكثر حماية من الشمس والمطر والبرد والثلج والعوامل الخارجية.',
    cta: 'أريد مرآبًا لفيلتي',
  },
  s7: {
    title: 'حلول معمارية شاملة لفيلتك',
    subtitle: 'مرآب فاخر + حديقة شتوية',
    cta: 'اطلب معلومات عن مشروعي',
  },
  s8: {
    title: 'كيف يبدأ مشروعك؟',
    step1: 'شارك مساحتك',
    step1d: 'أرسل لنا التفاصيل الأساسية عن فيلتك أو مشروعك.',
    step2: 'حدد الحاجة',
    step2d: 'دعنا نوضح معًا سعة المركبات وسيناريوهات الاستخدام.',
    step3: 'نهج التصميم',
    step3d: 'دعنا نطور نهج تصميم مخصص يناسب عمارتك.',
    step4: 'عرض السعر',
    step4d: 'دعنا نقدم لك عرض سعر مخصص حسب نطاق المشروع.',
    step5: 'التنفيذ',
    step5d: 'بعد الموافقة، دعنا ننفذ العمل كما هو مخطط.',
  },
  s9: {
    title: 'مشاريع مرآب ملهمة',
    filterAll: 'الكل',
    filterSingle: 'سيارة واحدة',
    filterDouble: 'سيارتان',
    filterVilla: 'مشاريع الفلل',
    filterWinter: 'الحديقة الشتوية',
  },
  s10: {
    title: 'لنصمم حلًا مخصصًا لفيلتك أو مشروعك.',
  },
  form: {
    name: 'الاسم الكامل',
    namePh: 'اسمك الكامل',
    phone: 'الهاتف',
    phonePh: '+90 5xx xxx xx xx',
    email: 'البريد الإلكتروني',
    emailPh: 'example@email.com',
    city: 'المدينة',
    cityPh: 'مدينتك',
    customerType: 'نوع العميل',
    solution: 'الحل الذي يهمك',
    projectStatus: 'حالة المشروع / الأرض',
    message: 'الرسالة',
    messagePh: 'صف مشروعك باختصار...',
    upload: 'رفع صورة',
    uploadHint: 'يمكنك رفع صور للأرض أو الفيلا أو صور مرجعية',
    submit: 'أرسل مشروعي',
    success: 'تم استلام طلبك. سنتواصل معك قريبًا.',
    error: 'حدث خطأ ما. يرجى المحاولة مرة أخرى.',
    customer: {
      villaOwner: 'مالك فيلا',
      construction: 'شركة مقاولات',
      developer: 'مطور مشاريع',
      architect: 'مهندس معماري',
      investor: 'مستثمر',
      other: 'أخرى',
    },
    solutionOpt: {
      single: 'مرآب لسيارة واحدة',
      double: 'مرآب لسيارتين',
      villaProject: 'مشروع فيلا',
      winterGarden: 'حديقة شتوية',
      combined: 'مرآب + حديقة شتوية',
      custom: 'مشروع خاص',
    },
    status: {
      land: 'لدي أرض / قطعة',
      construction: 'الفيلا قيد الإنشاء',
      existing: 'فيلا قائمة',
      none: 'لا توجد أرض بعد',
      other: 'أخرى',
    },
  },
  whatsapp: {
    message: 'مرحبًا VILLAGARAGE، أرغب في الحصول على معلومات وعرض سعر لمشروع الفيلا / المرآب الخاص بي.',
  },
  mobile: {
    cta: 'اطلب معلومات عن مشروعك',
  },
  faq: {
    title: 'الأسئلة الشائعة',
    q1: 'هل يمكن تطبيقه على الفلل القائمة؟',
    a1: 'نعم. نقدم حلولًا تناسب الفلل الجديدة والقائمة على حد سواء. بالنسبة للفلل القائمة، يتم تنفيذ مخصص بعد تقييم المساحة والبنية المعمارية.',
    q2: 'هل تتوفر أنظمة لسيارة أو سيارتين؟',
    a2: 'نعم، تتوفر أنظمة المرآب الفاخرة لسيارة أو سيارتين. كما نطور حلولًا متعددة مخصصة لكل مشروع.',
    q3: 'هل يتم تطبيق نفس النموذج على كل فيلا؟',
    a3: 'لا. يتم تصميم كل مشروع خصيصًا وفقًا لعمارة الفيلا وأبعادها واحتياجات العميل؛ ولا يُستخدم نموذج قياسي.',
    q4: 'هل تعملون في مشاريع الفلل المتعددة؟',
    a4: 'نعم، نعمل مع شركات المقاولات ومطوري المشاريع في مشاريع الفلل المتعددة، ونقدم حلولًا مخصصة لكل مشروع.',
    q5: 'هل يمكن بناء حديقة شتوية أيضًا؟',
    a5: 'نعم. بالإضافة إلى أنظمة المرآب، نقدم حلول الحديقة الشتوية وحلول المرآب + الحديقة الشتوية المتكاملة.',
    q6: 'كيف يتم تحديد السعر؟',
    a6: 'يتم تحديد السعر وفقًا للأبعاد وسعة المركبات والتفاصيل المعمارية وتفضيلات المواد ونطاق المشروع.',
    q7: 'كيف يمكنني إرسال مشروعي؟',
    a7: 'يمكنك ملء النموذج على موقعنا، أو التواصل عبر واتساب (+90 542 799 47 89)، أو إرسال رسالة عبر إنستغرام (@villagarage90).',
  },
  about: {
    title: 'من نحن',
    text: 'VILLAGARAGE هي علامة تجارية تطور حلولًا معمارية للمرائب الفاخرة للفلل ومساحات المعيشة الخارجية. تتعامل مع المرآب ليس كبنية مستقلة بل كجزء لا يتجزأ من عمارة الفيلا، مضيفة قيمة دائمة لمساحات المعيشة من خلال أنظمة الأنثراسيت وتفاصيل الخشب الطبيعي وتصاميم الواجهات المخصصة. بالعمل مع مالكي الفلل والمهندسين المعماريين والمقاولين ومطوري المشاريع، تقدم حلولًا فاخرة مصممة لكل حاجة ومتكاملة مع العمارة.',
  },
  final: {
    title: 'أكمل عمارة فيلتك بمرآبك.',
    cta1: 'اطلب عرض سعر لمشروعك',
    cta2: 'تواصل معنا عبر واتساب',
  },
  roles: {
    member: 'عضو عادي',
    dealer_a: 'وكيل الفئة A',
    dealer_b: 'وكيل الفئة B',
    dealer_c: 'وكيل الفئة C',
    distributor: 'موزّع',
    architect: 'مهندس معماري',
    construction: 'شركة إنشاءات',
    realtor: 'وسيط عقاري',
    admin: 'مدير',
  },
  catalog: {
    title: 'أنظمة المرآب',
    all: 'الكل',
    cat: {
      standard: 'المرائب القياسية',
      custom: 'مرائب بتصميم خاص',
      luxury: 'المرائب الفاخرة',
    },
    tag: {
      new: 'جديد',
      single: 'سيارة واحدة',
      double: 'سيارتان',
      premium: 'بريميوم',
      project: 'خاص بالمشروع',
    },
    capacityLabel: 'سعة السيارات',
    singleCar: 'سيارة واحدة',
    doubleCar: 'سيارتان',
    multiCar: 'عدة سيارات',
    quote: 'اطلب عرض سعر',
    details: 'التفاصيل',
    addToCart: 'أضف إلى السلة',
    projectQuote: 'إنشاء عرض سعر خاص بالمشروع',
    from: 'يبدأ من',
    priceOnRequest: 'اطلب عرض سعر لمعرفة السعر',
    empty: 'لا توجد منتجات في هذه الفئة بعد.',
    p1: { desc: 'مرآب فاخر مدمج وأنيق ومصمم حسب العمارة لسيارة واحدة.' },
    p2: { desc: 'مرآب فاخر واسع ومريح يندمج بسلاسة مع فيلتك لسيارتين.' },
    p3: { desc: 'مرآب مخصص لسيارة واحدة مصمم خصيصًا لفيلتك ومتكامل مع عمارتها.' },
    p4: { desc: 'حل مرآب معماري بسيارتين بتصميم مخصص.' },
    p5: { desc: 'مرآب فيلا فاخر بأرقى المواد والتفاصيل.' },
    p6: { desc: 'أنظمة مرآب مخصصة حسب المشروع لمشاريع الفلل المتعددة.' },
  },
  currency: {
    label: 'العملة',
    planned: 'قريباً',
  },
  auth: {
    title: 'دخول الأعضاء / الوكلاء',
    subtitle: 'الوصول إلى لوحتك وأسعارك الخاصة بدورك.',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    submit: 'تسجيل الدخول',
    note: 'سيتم تفعيل تسجيل الدخول الآمن والتصريح حسب الدور بعد اكتمال الاتصال بالواجهة الخلفية.',
    comingSoon: 'طبقة تسجيل الدخول جاهزة. سيتم تفعيل هذه الشاشة بعد اكتمال الاتصال الآمن بالواجهة الخلفية.',
    roleInfoTitle: 'وصول حسب الدور',
    roleInfoText: 'يتم دعم العضو العادي ووكلاء الفئة A/B/C والموزّع والمهندس المعماري وشركة الإنشاءات والوسيط العقاري والمدير. كل دور يرى فقط المجالات المصرّح له بها؛ ويتم تطبيق التصريح على الخادم.',
    applyCta: 'تقدّم بطلب الوكالة والشراكة',
    backHome: 'العودة إلى الصفحة الرئيسية',
  },
  dealer: {
    badge: 'شبكة الشراكة',
    heroTitle: 'انضم إلى شبكة شراكة VILLAGARAGE',
    heroSubtitle: 'قدّم أنظمة VILLAGARAGE المتميزة للمرآب لعملائك في تركيا والأسواق الدولية.',
    heroCta: 'قدّم الآن',
    modelsTitle: 'نماذج العضوية والوكالة',
    modelsSubtitle: 'هيكل لكل مستوى، من العملاء الأفراد إلى الوكلاء المحترفين.',
    cardCta: 'معلومات مفصلة وتقديم الطلب',
    models: {
      standard: { name: 'عضوية قياسية', desc: 'عضوية أساسية للعملاء الأفراد والأعضاء العاديين.' },
      a: { name: 'وكالة الفئة A', desc: 'النموذج الأكثر شمولاً. يتم تحديد الخصومات والحصص والتأمين ومزايا الدفع من قبل المدير.' },
      b: { name: 'وكالة الفئة B', desc: 'نموذج شراكة متوازن للوكلاء المتوسطين.' },
      c: { name: 'وكالة الفئة C', desc: 'نموذج شراكة للمستوى المبتدئ للوكلاء الجدد.' },
    },
    proTitle: 'الشراكة المهنية',
    proSubtitle: 'نموذج شراكة مرن للمحترفين الذين يوجّهون المشاريع والعملاء.',
    proSectors: 'مهندسون معماريون • شركات إنشاءات • وسطاء عقاريون • موزّعون',
    partnerCta: 'كن شريكاً',
    partnersTitle: 'نماذج الشراكة',
    partners: {
      distributor: 'موزّع',
      architect: 'مهندس معماري',
      construction: 'شركة إنشاءات',
      realtor: 'وسيط عقاري',
      other: 'شريك آخر',
    },
    partnersNote: 'بدون حصة أو تأمين للوكيل؛ كل مجموعة تحصل على خصمها وميزتها السعرية ومستوى صلاحيتها الخاص.',
    termsTitle: 'شروط خاصة بكل فئة',
    termsText: 'يتم تحديد نسب الخصم وحصص الشراء ومبالغ التأمين ومزايا الدفع بشكل منفصل لكل فئة وكالة وإدارتها من لوحة الإدارة. هذه القيم غير ثابتة حالياً.',
    rolesTitle: 'هيكل الأدوار',
    rolesSubtitle: 'كل مستخدم يرى فقط المجالات المسموح بها لدوره؛ ويتم تطبيق التصريح على الخادم بعد ربط واجهة خلفية آمنة.',
    form: {
      title: 'نموذج التقديم',
      subtitle: 'املأ النموذج أدناه؛ سيتم استلام طلبك للتقييم.',
      name: 'الاسم الكامل',
      company: 'اسم الشركة',
      phone: 'الهاتف',
      email: 'البريد الإلكتروني',
      country: 'الدولة',
      city: 'المدينة',
      website: 'الموقع الإلكتروني',
      instagram: 'إنستغرام',
      field: 'مجال النشاط',
      applicationType: 'نوع الطلب',
      selectPlaceholder: 'اختر',
      howToWork: 'كيف ترغب في العمل مع VILLAGARAGE؟',
      messagePh: 'أخبرنا باختصار...',
      submit: 'إرسال طلبي',
      success: 'تم استلام طلبك للتقييم.',
      error: 'حدث خطأ ما. يرجى المحاولة مرة أخرى.',
    },
  },
  footer: {
    tagline: 'Premium Garage Systems',
    navTitle: 'القائمة',
    contactTitle: 'اتصل بنا',
    instagram: 'إنستغرام',
    copyright: 'جميع الحقوق محفوظة.',
  },
};